import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ImprimeTicketComponent } from '../../imprime-ticket/imprime-ticket.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { CancelaTicketComponent } from 'src/app/cancela-ticket/cancela-ticket.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-indicadores-saac',
  templateUrl: './indicadores-saac.component.html',
  styleUrls: ['./indicadores-saac.component.css'],
  providers: [
    { provide: MatDialogRef,useValue: {} },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})

export class IndicadoresSAACComponent implements OnInit {
  errMsg:any;
  roles:any=[];
  prods:any=[];
  descs:any=[];
  gpo:any=[];
  loading:boolean=false;
  fecIni:any = moment();
  fecFin:any = moment();
  
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.loading = true;
    this.dataService.getGrupos().subscribe(
                      rows => {   
                              this.gpo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGruposCargados());
  }

  fnGruposCargados(){
    console.log(this.gpo);

  }

}
